// extracted by mini-css-extract-plugin
export var container = "styles-module--container--JvTGn";
export var cta = "styles-module--cta--3sfmT";
export var fadeIn = "styles-module--fadeIn--K+8N3";
export var fadeInAndMoveUp = "styles-module--fadeInAndMoveUp--BtV4W";
export var headline = "styles-module--headline--Pf8Vb";
export var icon = "styles-module--icon--mP8fD";
export var iconContainer = "styles-module--iconContainer--nD48K";
export var scaleUp = "styles-module--scaleUp--quLJ-";
export var slideIn = "styles-module--slideIn--NB2Ii";